import { createContext } from "react";

/**
 * Desktop sidebar state — persisted user preference (localStorage), sm+ only.
 */
const DesktopLayoutContext = createContext<{
    isSidebarCollapsed: boolean;
    setIsSidebarCollapsed: (value: boolean) => void;
}>({
    isSidebarCollapsed: false,
    setIsSidebarCollapsed: () => {},
});

export default DesktopLayoutContext;
